import {colors} from 'app/backoffice/House/ReservationsView'
import {calcFirstAvailableDate} from 'app/lib/calcPrice'
import {
	DTRG_BLOCK,
	DTRG_CONTRACT,
	DTRG_PRICE,
} from 'app/_server/database/constants'

/** @param {House['switchDay']} switchDay */
export const makeSwitchDayStyle = switchDay =>
	switchDay && {
		day: switchDay,
		color: 'rgba(0, 128, 0, 0.5)',
	}

/**
 * @param {Contract['beginDate']} beginDate
 * @param {House['prices']} prices
 */
export const makeInitialDate = (beginDate, prices = []) =>
	beginDate ? new Date(beginDate) : calcFirstAvailableDate(prices)

/**
 * @param {DateRangeItem[]} dateRanges
 * @returns {DateRangeItem[]}
 */
export const makeDateStates = dateRanges => {
	const dateStates = []
	for (const item of dateRanges) {
		if (
			item.type === DTRG_CONTRACT ||
			item.type === DTRG_BLOCK ||
			(item.type === DTRG_PRICE && item.sell === 0)
		) {
			const desiredColor = item.isOption
				? 'option'
				: item.type === DTRG_PRICE
					? 'noSell'
					: item.type
			dateStates.push({
				...item,
				type: String(desiredColor),
				start: item.beginDate,
				end: item.endDate,
				color: colors[desiredColor] && `rgba(${colors[desiredColor]})`,
			})
		}
	}

	return dateStates
}
